<template>
    <div v-if="lang" class="desktop-estate-filters">
        <div class="search-bar-desk">
            <autocomplete-filter
                v-if="['estate', 'construction'].includes(section) && config.mode == 'autocomplete'"
                class="filter-geo-autocomplete"
                :contract="filters.contract ? filters.contract : ''"
                :config="config"
                :config_map="config_map"
                :districts="districts"
                :filters="filters"
                :geo_data="geo_data"
                :placeholder="placeholder"
                :polygon_id="filters.polygon_id"
                :searchData="searchData"
                :section="section"
                :sector="filters.sector ? filters.sector : ''"
                @input="updateGeo"
                @updated="filtersUpdated"
            />

            <geo-select
                v-else-if="section === 'estate' && config.mode == 'select'"
                class="filter-geo-select"
                :contract="filters.contract ? filters.contract : ''"
                :section="section"
                :sector="filters.sector ? filters.sector : ''"
                :searchData="searchData"
                :config="config"
                :config_map="config_map"
                @input="updateGeo"
            ></geo-select>
        </div>

        <filter-select
            v-if="section == 'estate'"
            class="filter-contract"
            v-model="filters.contract"
            :allow-empty="false"
            :items="filterValues.contracts"
            :label="lang.labels.contract | capitalize"
            name="contract"
            @updated="filtersUpdated"
        />

        <filter-select
            v-if="section == 'estate'"
            class="filter-type"
            v-model="filters.type"
            :items="filterValues.types_list"
            :label="lang.labels.type | capitalize"
            name="type" clearable
            @updated="filtersUpdated('type')"
        />

        <my-range-input
            v-if="section == 'estate'"
            class="filter-price"
            type="number"
            min="0"
            :labels="lang.labels"
            :unit="lang.units.currency"
            :filters="filters"
            :default-values="defaultValues.price"
            main-label="price"
            min-value-key="min_price"
            max-value-key="max_price"
            @updated="filtersUpdated"
        />

        <my-range-input
            v-if="section == 'estate'"
            class="filter-surface"
            type="number"
            min="0"
            :labels="lang.labels"
            :unit="lang.units.surface"
            :filters="filters"
            :default-values="defaultValues.surface"
            main-label="surface"
            min-value-key="min_surface"
            max-value-key="max_surface"
            @updated="filtersUpdated"
        />

        <div class="other-filters-container" v-if="section == 'estate'" width="16"  height="16">
            <button
                type="button"
                class="btn btn-text"
                @click.prevent.stop="toggleOtherFilters"
            >
                {{ trans('labels.other_filters') | capitalize}}
                <div
                    v-if="secondaryFiltersLength"
                    class="badge"
                    :class="'badge-' + $root.network"
                >
                    {{ secondaryFiltersLength }}
                </div>
                <img src="/img/icons/filters.svg">
            </button>

            <div 
                v-show="show_more" 
                class="other-filters" 
                id="other-filters"
            >
                <secondary-filters
                    :config="config"
                    :count="count"
                    :fallback="fallback"
                    :filters="filters"
                    :filter-values="filterValues"
                    :lang="lang"
                    @updated="filtersUpdated"
                    @close="toggleOtherFilters"
                />
            </div>
        </div>

        <!-- <button class="btn btn-network">
            {{ lang.labels.search }}
        </button> -->

        <button
            type="button"
            class="btn btn-network save-search-button btn-md"
            @click.prevent="openSaveSearchModal"
            v-if="section == 'estate'"
            :disabled="save_search_disable"
        >            
            <masked-image :src="'/img/icons/notifications.svg'"></masked-image>            
            {{ lang.labels.save_search }}
        </button>
    </div>
</template>

<script>
import Autocomplete from './filters/Autocomplete'
import FilterSelect from './filters/Select'
import SecondaryFilters from './filters/SecondaryFilters'
import MyRangeInput from './filters/MyRangeInput'
import GeoSelect from '../GeoSelect'

import { countObject, filterObject, filterObjectByKey } from '../../helpers/objects'

export default {
    components: {
        'autocomplete-filter': Autocomplete,
        'filter-select': FilterSelect,
        'secondary-filters': SecondaryFilters,
        'my-range-input': MyRangeInput,
        'geo-select': GeoSelect,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        districts: {
            type: Array,
            required: false,
        },
        
        count: {
            type: Number,
            required: true,
        },

        defaultValues: {
            type: Object,
            required: true,
        },

        fallback: {
            type: Boolean,
            required: true,
        },

        filters: {
            type: Object,
            required: true,
        },

        filterValues: {
            type: Object,
            required: true,
        },

        geo_data: {
            type: Object,
            required: true,
        },

        lang: {
            type: Object,
            required: true,
        },

        placeholder: {
            type: String,
            required: false,
        },

        saveSearchDisable: {
            type: Boolean,
            default: false,
        },

        searchData: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            required: true,
        },

        sector: {
            type: String,
            default: 'res',
        },
    },

    data() {
        return {
            secondary_filters: null,
            save_search_disable: this.saveSearchDisable,
            show_more: false
        }
    },

    created() {
        this.watchClickOutside()

        window.events.$on('update-save-search-disable', disable => {
            this.save_search_disable = disable
        })
    },

    mounted() {
        this.secondaryFilters()
    },

    computed: {
        secondaryFiltersLength() {
            return countObject(this.secondary_filters)
        },
    },

    methods: {
        openSaveSearchModal() {
            if (this.$root.country == 'it' && !this.is_logged_in()) {
                window.events.$on('login_completed', () => {
                    this.openSaveSearchModal()
                })

                window.events.$emit('showModal', { name: 'login', data: { action: true }})
            } else {
                window.events.$emit('showModal', { name: 'save_search' })
            }
        },

        toggleOtherFilters() {
            this.show_more = ! this.show_more
        },

        updateGeo(event) {
            this.$emit('update-geo', event)
        },

        filtersUpdated(event) {
            // if (event == 'type') {
            //     window.events.$emit('reset-subsubtype', event)
            // }
            this.secondaryFilters()
            this.$emit('filters-updated', event)
        },

        secondaryFilters() {
            let secondary_filters = [
                'air_conditioning',
                'balcony',
                'bathrooms',
                'concierge',
                'furnitured',
                'furnitured_tecnocasa',
                'garage',
                'garage_tecnocasa',
                'garden',
                'garden_tecnocasa',
                'heating',
                'heating_tecnocasa',
                'lift',
                'max_rooms',
                'min_ce',
                'min_rooms',
                'property_type',
                'status',
                'status_tecnocasa',
                'subsubtype',
                'swimming_pool',
                'terrace',
                'virtual_tour',
            ]

            let filters = filterObjectByKey(this.filters, key => {
                return secondary_filters.indexOf(key) > -1
            })

            filters = filterObject(filters, item => {
                return item
            })

            this.secondary_filters = filters
        },

        watchClickOutside() {
            window.addEventListener('click', e => {
                
                if(this.show_more) {
                
                    let container = document.getElementById('other-filters')

                    if (! container.contains(e.target) ) {
                        this.show_more = false
                    }   
                }
            })
        },

    },
}
</script>